var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.className, 'loader'],attrs:{"title":_vm.title}},[_c('Icon',{attrs:{"name":'loader',"size":_vm.iconSize,"color":_vm.color}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }